<template>

                        <div class="Navigations">
                            <div class="big_button" v-for="(m,index) of menu" :key="'menu' + index" @click="gotoMenu(m.path)">
                                <div v-if="m.svg !== null" v-html="m.svg" class="svgs">

                                </div>
                                <div v-else></div>
                                <p>{{m.name}}</p>
                            </div>
                            <div class="big_button fullexit" @click="exitAuth()">
                                <div class="blex">
                                <div class="svgs">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                    <path d="M15 8L19 12M19 12L15 16M19 12H9" stroke="currentColor" stroke-linecap="round"></path>
                                    <path d="M5 4H9C10.1046 4 11 4.89543 11 6V18C11 19.1046 10.1046 20 9 20H5" stroke="currentColor" stroke-linecap="round"></path>
                                </svg>
                                </div>
                               <p>Выход</p>
                               </div>
                            </div>
                        </div>

</template>

<script setup>

import role from '@/role'
import { useRoute, useRouter } from 'vue-router'
import { exitUser } from '@/controlles/auth'
import { headMenu } from '@/controlles/general'

const r = useRouter()
const rt = useRoute()
const menu = role.headermenu.getMenuHeader()
const exitAuth = () => {
  exitUser()
  location.reload()
}
const gotoMenu = (path) => {
  r.push({ name: path })
  if (path == rt.name) {
    headMenu.value = false
  }
}

</script>

<style scoped>

.Navigations{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    align-items: center;
    justify-items: center;
    gap: 10px;
    margin-top: 10px;

}
p{
    font-size: 13px;
    font-weight: 400;
}

.svgs{
    width: 48px;
    height: 48px;
    background-color: var(--accent-light-gray);
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a1a1a;
    transition: background 0.2s;
}
html.dark .svgs :deep(svg path), 
html.dark .svgs :deep(svg circle),
html.dark .svgs :deep(svg rect) {
    
       stroke: rgb(255 255 255 / 70%);
}
.big_button{
    display: grid;
    align-items: center;
    justify-items: center;
    gap: 20px;
    justify-content: center;
}
.big_button::after{
    display: none;
}

.fullexit{
        grid-column: 1 / -1;
}
.fullexit{

}

.blex{
    display: grid;
    grid-template-columns: auto auto;
    width: max-content;
    gap:20px;
        align-items: center;
}
</style>
